import { useContext } from 'react';
import { __RouterContext as RouterContext } from 'react-router';
import { compile } from 'path-to-regexp';

export const useRouter = () => useContext(RouterContext);

export const endsInWildcard = path => path.match(/\*$/);

// often times we'll add a * to the end of a route to indicate
// a child switch will take over the handling of redirects
// this utility function removes the params that matched the wildcard route
// so they can be handled by child routes
export const urlForMatch = ({ params, path }) =>
  compile(path)(endsInWildcard(path) ? { 0: '' } : params);
